export default {
    new: 'Novo projeto',
    delete: 'Eliminar projeto',
    edit: 'Editar projeto',
    showActives: 'Mostrar projetos ativos',

    sections: {
        datasets: 'Conjuntos de dados',
        models: 'Modelos',
        discovery: 'Descoberta',
        queries: 'Conhecimentos',
    },

    notifications: {
        noResult: {
            title: 'Nenhum resultado encontrado',
            text: 'Não foram encontrados projectos para a sua pesquisa.',
        },
        empty: {
            title: 'Não foram encontrados projectos',
            text: 'Pode criar o seu primeiro projeto.',
        },
        created: {
            text: 'Projeto criado com sucesso.',
        },
        updated: {
            text: 'Projeto atualizado com êxito.',
        },
        deleted: {
            text: 'Projeto eliminado com êxito.',
        },
        archived: {
            text: 'Projeto arquivado com êxito.',
        },
    },

    modals: {
        delete: {
            text: 'Tem a certeza de que pretende eliminar o projeto "{nome}"?',
        },
        upload: {
            title: 'Carregar dados',
            text: 'Escolha um ficheiro .csv para carregar',
        },
        replace: {
            title: 'Substituir dados',
            text: 'Escolha um ficheiro .csv para substituir os dados existentes',
        },
    },

    datasets: {
        new: 'Importar dados do registo do processo',
        delete: 'Eliminar processo',
        edit: 'Editar informação do processo',
        infoText: 'Informação do processo',
        errors: 'Erros',
        errorMessage: 'Não estão atualmente disponíveis mais informações sobre este processo.',
        generalError: 'Ocorreu um erro não identificado ao processar os dados de origem. Por favor, contacte o administrador do sistema.',
        notUploadedWarning: 'Os dados deste processo ainda não foram carregados. As métricas, avisos e erros aparecerão quando o carregamento e a configuração estiverem concluídos.',
        notConfiguredWarning: 'Este processo ainda não foi configurado. Conclua a configuração dos campos-chave para iniciar o processamento.',
        resumeUpload: 'Retomar carregamento',
        resumeConfiguration: 'Configurar campos-chave',

        moveDataset: 'Mover processo',
        createdByMe: 'Criadas por mim',
        sharedWithMe: 'Compartilhadas comigo',
        move: 'Mover',
        missingData: 'Faltam dados necessários para mover o processo.',
        sameProjectError: 'Não pode mover o processo para o mesmo projeto.',
        moveSuccess: 'Processo movido com sucesso.',

        import: 'Conectores',
        discovery: 'Descoberta',
        query: 'Insight',
        sortBy: 'Ordenar por',
        sortByOptions: {
            name: 'Nome',
            createdAt: 'Criado em',
        },
        sortDirection: {
            ascending: 'Crescente',
            descending: 'Decrescente',
        },

        properties: {
            events: 'Eventos',
            activities: 'Actividades',
            arcs: 'Arcos',
            traces: 'Casos',
            variants: 'Variantes',
            createdAt: 'Criado',
            sourceType: 'Tipo de fonte',
            source: 'Fonte',
        },
        notifications: {
            noResult: {
                title: 'Nenhum resultado encontrado',
                text: 'Não encontrámos nenhum processo para a sua pesquisa.',
            },
            empty: {
                title: 'Nenhum processo encontrado',
                text: 'Pode importar dados para o seu primeiro processo.',
            },
            created: {
                text: 'Processo criado com sucesso.',
            },
            updated: {
                text: 'Processo atualizado com sucesso.',
            },
            deleted: {
                text: 'Processo eliminado com sucesso.',
            },
        },
        states: {
            running: 'PROCESSAMENTO',
            submitted: 'A SUBMETER',
            incomplete: 'INCOMPLETO',
            finished: 'PRONTO',
            error: 'ERRO',
            cancelled: 'CANCELADO',
            timeout: 'TEMPO ESGOTADO',
        },

        settings: {
            title: 'Informações do conjunto de dados',
            back: 'Voltar à vista dos conjuntos de dados',
            tabs: {
                general: 'Geral',
                updates: 'Actualizações em tempo real',
                errors: 'Erros',
                warnings: 'Avisos',
            },
            general: {
                nameTitle: 'Nome do conjunto de dados',
                nameField: 'Nome do atributo',
                descriptionField: 'Descrição',
                updateName: 'Atualização',
                generalTitle: 'Informação geral',
                sourceType: 'Tipo de fonte',
                sourceName: 'Nome da fonte',
                creation: 'Data de criação',
                lastUpdate: 'Última atualização',
                metricsTitle: 'Métricas de registo e de processo',
                events: 'Eventos',
                activities: 'Actividades',
                cases: 'Casos',
                variants: 'Variantes',
                arcs: 'Arcos',
            },
            updates: {
                pushTitle: 'Actualizações push',
                pushEnabled: 'As actualizações de dados por push através da API estão activadas',
                pushDisabled: 'As actualizações de dados push através da API estão desactivadas',
                pullTitle: 'Actualizações pull',
                pullToggle: 'Ativar actualizações de dados pull',
                frequency: 'Frequência de atualização (aplica-se desde a última atualização)',
                value: 'Valor',
                unit: 'Unidade',
                evalValue: 'Só são permitidos valores numéricos até 60',
                timeGranularity: {
                    minutes: 'minutos',
                    hours: 'horas',
                    days: 'dias',
                    weeks: 'semanas',
                    months: 'meses',
                },
                saveChanges: 'Guardar alterações',
                notReady: 'Este conjunto de dados não está pronto e não pode ser atualizado',
            },
            errors: {
                noErrors: 'Não foram encontrados erros para este conjunto de dados',
                title: 'Avisos e Erros',
            },
            okMessage: 'Configurações actualizadas corretamente',
            failMessage: 'Verificar os valores de configuração antes de guardar as alterações',
        },

        modals: {
            delete: {
                text: 'Tem a certeza de que pretende eliminar o conjunto de dados "{nome}"?',
            },
            discovery: {
                text: 'Tem a certeza de que pretende criar uma nova descoberta?',
            },
        },
    },

    models: {
        upload: 'Carregar BPMN',
        empty: {
            title: 'Nenhum modelo encontrado',
            text: 'Pode importar o seu primeiro modelo BPMN',
        },
        edit: 'Atualizar o nome do modelo',
        delete: 'Eliminar modelo',
        preview: 'Pré-visualizar modelo',
        notifications: {
            noResult: {
                title: 'Nenhum resultado encontrado',
                text: 'Não encontrámos nenhum modelo para a sua pesquisa.',
            },
            empty: {
                title: 'Nenhum modelo encontrado',
                text: 'Pode importar o seu primeiro modelo.',
            },
            created: {
                text: 'Modelo importado com sucesso.',
            },
            updated: {
                text: 'Modelo atualizado com sucesso.',
            },
            deleted: {
                text: 'Modelo eliminado com sucesso.',
            },
        },
        source: {
            uploaded: 'CARREGADO',
            dataset: 'CONJUNTO DE DADOS',
        },
        modals: {
            delete: {
                text: 'Tem a certeza de que pretende eliminar este modelo?',
            },
            upload: {
                title: 'Carregar modelo BPMN',
                name: 'Nome do modelo',
                file: 'Escolher um ficheiro BPMN',
                submit: 'Importar',
                rejected: 'Só são permitidos ficheiros BPMN até 1MB.',
            },
        },

        drawer: {
            summaryTitle: 'Resumo do diagrama',
            parseError: 'Não foi possível analisar este diagrama BPMN.',
            tasks: 'Tarefas',
            events: 'Eventos',
            gateways: 'Gateways',
            flows: 'Fluxos',
            pools: 'Pools',
            lanes: 'Lanes',
            subprocesses: 'Subprocessos',
        },
    },

    discoveries: {
        new: 'Nova descoberta',
        cancel: 'Cancelar descoberta',
        delete: 'Eliminar descoberta',
        edit: 'Editar descoberta',

        notifications: {
            noResult: {
                title: 'Nenhum resultado encontrado',
                text: 'Não foram encontradas descobertas para a sua pesquisa.',
            },
            empty: {
                title: 'Não foram encontradas descobertas',
                text: 'Pode efetuar a sua primeira descoberta.',
            },
            created: {
                text: 'Descoberta criada com sucesso.',
            },
            updated: {
                text: 'Descoberta actualizada com êxito.',
            },
            deleted: {
                text: 'Descoberta eliminada com êxito.',
            },
            archived: {
                text: 'Descoberta arquivada com êxito.',
            },
        },

        modals: {
            cancel: {
                text: 'Tem a certeza de que pretende cancelar esta descoberta?',
            },
            delete: {
                text: 'Tem a certeza de que pretende apagar esta descoberta?',
            },
        },
    },

    queries: {
        new: 'Nova descoberta',
        cancel: 'Cancelar descoberta',
        delete: 'Eliminar descoberta',
        edit: 'Editar descoberta',

        notifications: {
            noResult: {
                title: 'Não foram encontrados resultados',
                text: 'Não foram encontradas ideias para a sua pesquisa.',
            },
            empty: {
                title: 'Não foram encontradas ideias',
                text: 'Pode criar a sua primeira ideia.',
            },
            created: {
                text: 'Ideias criadas com sucesso.',
            },
            updated: {
                text: 'Insight atualizado com sucesso.',
            },
            deleted: {
                text: 'Ideias eliminadas com êxito.',
            },
            cancel: {
                text: 'Idéia cancelada com sucesso.',
            },
            download: {
                text: 'Perceção descarregada com êxito.',
            },
        },
        states: {
            running: 'PROCESSAMENTO',
            submitted: 'A SUBMETER',
            finished: 'PRONTO',
            error: 'ERRO',
        },

        modals: {
            cancel: {
                text: 'Tem a certeza de que pretende cancelar esta ideia?',
            },
            delete: {
                text: 'Tem a certeza de que pretende eliminar esta ideia?',
            },
        },
    },
    variants: {
        changeOrderCriteria: 'Alterar critério de ordenação',
        order: {
            frequency: 'Frequência',
            mean: 'Duração média',
            median: 'Duração mediana',
            deviation: 'Desvio padrão da duração',
        },
        orderAbbreviations: {
            frequency: 'freq',
            mean: 'média',
            median: 'med',
            deviation: 'dp',
        },
        changeOrder: 'Alterar ordenação',
        orderOptions: {
            ascending: 'Crescente',
            descending: 'Decrescente',
        },
        orderOptionsAbbreviations: {
            ascending: 'cresc',
            descending: 'desc',
        },
    },
}
